import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";
import ic_plus_msg from "../../assets/images/chat/ic_plus_msg.svg";
import ic_dropdown from "../../assets/images/chat/ic_dropdown.svg";
import Beatloader from "../../sharedComponent/Beatloader";
import "../../assets/css/main.scss";
import Accordion from "react-bootstrap/Accordion";
import ChatBox from "./ChatBox";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import searchicon from "../../assets/images/ic_search.svg";
import ic_search_dark from "../../assets/images/ic_search_dark.svg";
import { Avatar, AvatarStack, Badge, Input, SearchIconButton } from "../../components/ui";

const mapUserStatus = (status) => {
  if (status === "online") return "online";
  if (status === "busy" || status === "do not desturb") return "busy";
  if (status === "away") return "away";
  return "offline";
};

// Sidebar preview helper. Two responsibilities:
//   1. Backend stores `lastmessage` in a column that doesn't preserve 4-byte
//      UTF-8, so emoji-only messages arrive as a run of literal "?" characters
//      ("??" / "????"). Surface a friendlier label so the user isn't confused
//      by raw question marks. Conservative: only triggers when the trimmed
//      message is composed entirely of "?" and is at least 2 chars long, so
//      legitimate text like "What?" or "??" punctuation isn't masked.
//   2. Truncate long previews so a wrapped run of text doesn't push the
//      sidebar layout. Previously the pinned list truncated but the recent
//      list didn't — now both go through the same path.
const getChatPreview = (text) => {
  if (text == null || text === "") return text;
  const str = String(text);
  if (/^\?+$/.test(str.trim()) && str.trim().length >= 2) {
    return "😊";
  }
  return str.length > 50 ? str.slice(0, 25) + ".." : str;
};

const Chat = () => {
  const {
    sidebar,
    socket,
    setLoading,
    // getRecentChats,
    setRecentChats,
    setPinnedChats,
    setConversations,
    setNewMessages,
    setPage,
    activeChat,
    setActiveChat,
    userData,
    currentSChannel,
    setCurrentSChannel,
    pinnedChats,
    recentChats,
    setNoMorePages,
    Dark,
    recentChatLdr,
    setRecentChatLdr,
    msgdelete,
    setmsgdelete
  } = useContext(AppContext);

  const [filteredChats, setFilteredChats] = useState([]);
  const getRecentChats = () => {
    setRecentChatLdr(true);
    socket && socket.emit("get-private-chat-list");
  };

  const [schannelName, setSchannelName] = useState(
    activeChat && activeChat.Team_Channel_Description
      ? activeChat.Team_Channel_Description
      : ""
  );
  useEffect(() => {
    if (msgdelete === true) {
      getAllRecentChats();
    }
    getAllRecentChats();
    // setActiveChat({})
    // setCurrentSChannel(null)
  }, [socket, msgdelete]);

  const mergeUnreadCounts = (prev, incoming, activeChannelId) => {
    if (!incoming) return prev;
    const isActive = (chat) =>
      activeChannelId != null && chat.Team_Channel_Id == activeChannelId;
    if (!Array.isArray(prev) || !prev.length) {
      return incoming.map((chat) =>
        isActive(chat) ? { ...chat, unread_count: 0 } : chat
      );
    }
    const prevMap = new Map(prev.map((c) => [c.Team_Channel_Id, c]));
    return incoming.map((chat) => {
      if (isActive(chat)) return { ...chat, unread_count: 0 };
      const local = prevMap.get(chat.Team_Channel_Id);
      if (!local) return chat;
      return {
        ...chat,
        unread_count: Math.max(
          Number(chat?.unread_count) || 0,
          Number(local?.unread_count) || 0
        ),
      };
    });
  };

  const getAllRecentChats = async () => {
    await getRecentChats();
    socket &&
      socket.on("get-private-chat-list", (data) => {
        setPinnedChats((prev) =>
          mergeUnreadCounts(prev, data.pinned, currentSChannel)
        );
        setmsgdelete(false)
        setRecentChats((prev) =>
          mergeUnreadCounts(prev, data.recent, currentSChannel)
        );
        setFilteredChats(data.recent);
        setRecentChatLdr(false);
      });

    return () => {
      if (socket) {
        socket.off("get-private-chat-list");
      }
    };
  };

  const [showResults, setShowResults] = useState(false);
  const onClick = () => setShowResults(!showResults);
  const [selectedList, setSelectedList] = useState([]);
  const joinRoom = (schannel_id) => {
    socket.emit("join-room", {
      schannel_id: schannel_id,
    });
  };

  useEffect(() => {
    if (!socket) return;
    const updateChannelName = (data) => {
      const { schannel_id, Team_Channel_Description } = data;
      setRecentChats((prevRecentChats) =>
        prevRecentChats.map((singleChat) =>
          singleChat.Team_Channel_Id == schannel_id
            ? { ...singleChat, Team_Channel_Description }
            : singleChat
        )
      );

      if (activeChat) {
        setActiveChat((prevActiveChat) => ({
          ...prevActiveChat,
          Team_Channel_Description,
        }));
      }
    };

    socket.on("update-schannel-name", updateChannelName);

    return () => {
      socket.off("update-schannel-name", updateChannelName);
    };
  }, [socket, activeChat]);

  const createChatRoom = () => {
    setSchannelName("");
    const body = JSON.stringify({
      members: selectedList.map((item) => item.id),
    });
    PostCallWithErrorResponse(ApiConfig.CREATE_CHATROOM, body)
      .then((res) => {
        setLoading(false);
        const { status, schannel_id } = res.json;

        if (status) {
          setCurrentSChannel(schannel_id);

          socket.emit("join-room", {
            schannel_id,
          });

          setShowResults(false);
          setPage(0);
          setNoMorePages(false);

          setActiveChat({ pin: false, ...res.json });
          getRecentChats();



          setShowResults(false);

          //


        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setConversations([]);
    setNewMessages([]);
    setPage(0);
  }, [currentSChannel]);

  useEffect(() => {
    socket &&
      socket.on("change-status", (data) => {
        setActiveChat({
          ...activeChat,
          em:
            activeChat.em &&
            activeChat.em.map((user) => {
              if (
                user.EmployeeId == data.userid ||
                user.User_Id == data.userid
              ) {
                return {
                  ...user,
                  user_status: data.user_status,
                  last_seen: data.last_seen,
                };
              }
              return user;
            }),
        });

        const applyStatusToChat = (chat) => ({
          ...chat,
          em: (chat.em || []).map((user) =>
            user.EmployeeId == data.userid
              ? {
                ...user,
                user_status: data.user_status,
                last_seen: data.last_seen,
              }
              : user
          ),
        });
        setRecentChats((prev) =>
          Array.isArray(prev) ? prev.map(applyStatusToChat) : prev
        );
        setPinnedChats((prev) =>
          Array.isArray(prev) ? prev.map(applyStatusToChat) : prev
        );
      });

    return () => {
      if (socket) {
        socket.off("change-status");
      }
    };
  }, [activeChat, socket]);

  const [isSearching, setisSearching] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  //For Search Recent
  useEffect(() => {
    const empId = userData && Number(userData?.EmpId);

    const recentChatsdata =
      filteredChats &&
      filteredChats.filter((item) => {
        if (item.Team_Channel_Description) {
          if (item.Team_Channel_Description === "private") {
            return item.em.some(
              (employee) =>
                employee.EmployeeId !== empId &&
                (employee.FirstName + " " + employee.LastName)
                  .toLowerCase()
                  .includes(searchValue.toLowerCase())
            );
          } else {
            return (
              item.Team_Channel_Description &&
              item?.Team_Channel_Description?.toLowerCase().includes(
                searchValue.toLowerCase()
              )
            );
          }
        } else {
          return item.em.some(
            (employee) =>
              employee.EmployeeId !== empId &&
              (employee.FirstName + " " + employee.LastName)
                .toLowerCase()
                .includes(searchValue.toLowerCase())
          );
        }
      });

    setRecentChats(recentChatsdata);
  }, [searchValue]);

  return (
    <>
      <div
        className={sidebar ? "" : "cx-active"}
        id="cx-main"
      >
        <div className="comm-layout">
          <aside className="comm-sidebar">
            <Tab.Container id="left-tabs-example" defaultActiveKey="1">
              {isSearching ? (
                <div className="comm-chatlist__search">
                  <Input
                    autoFocus
                    type="text"
                    placeholder="Search conversations"
                    className="comm-chatlist__search-input"
                    onBlur={() => setisSearching(false)}
                    onChange={(e) => setSearchValue(e.target.value)}
                    leftIcon={
                      <img
                        src={Dark === "lightMode" ? searchicon : ic_search_dark}
                        alt=""
                      />
                    }
                  />
                </div>
              ) : (
                <div className="comm-sidebar__header">
                  <div className="comm-sidebar__title">
                    <label>Chat</label>
                  </div>
                  <div className="comm-sidebar__actions">
                    <SearchIconButton
                      size="md"
                      variant="ghost"
                      onClick={() => setisSearching(true)}
                      aria-label="Search conversations"
                    />
                    <Link to="#" onClick={onClick} className="ms-4">
                      <img src={ic_plus_msg} alt="" />
                    </Link>
                  </div>
                </div>
              )}

              <div className="comm-divider"></div>

              <div className="comm-sidebar__list">
                <Accordion defaultActiveKey="1">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div className="comm-sidebar__section-label">
                          <div className="left">
                            <label htmlFor="">Pinned</label>
                          </div>
                          <div className="right">
                            <Link to="#">
                              <img src={ic_dropdown} alt="" className="pe-1" />
                            </Link>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Nav variant="pills" className="flex-column">
                          {pinnedChats && pinnedChats.length ? (
                            pinnedChats.map((chat, index) => {
                              let allusers =
                                chat &&
                                chat?.em
                                  .sort((a, b) => a.EmployeeId - b.EmployeeId)
                                  .filter(
                                    (user) => user.EmployeeId != userData.EmpId
                                  );
                              let user =
                                chat &&
                                chat?.em
                                  .sort((a, b) => a.EmployeeId - b.EmployeeId)
                                  .filter(
                                    (user) => user.EmployeeId != userData.EmpId
                                  )[0];

                              return (
                                <Nav.Item
                                  key={"pinned" + index}
                                  onClick={() => {
                                    setShowResults(false);

                                    setPage(0);
                                    setNoMorePages(false);
                                    setActiveChat({ pin: true, ...chat });
                                    setCurrentSChannel(
                                      chat && chat?.Team_Channel_Id
                                    );
                                    joinRoom(chat && chat?.Team_Channel_Id);
                                    // updatepinnedchatUnreadCount(
                                    //   chat && chat?.Team_Channel_Id
                                    // )
                                  }}
                                >
                                  <Nav.Link
                                    eventKey={chat.Team_Channel_Id}
                                    active={
                                      chat?.Team_Channel_Id ===
                                        activeChat?.Team_Channel_Id &&
                                        activeChat?.Team_Channel_Id
                                        ? true
                                        : false
                                    }
                                    className={
                                      chat?.Team_Channel_Id ===
                                      activeChat?.Team_Channel_Id &&
                                      activeChat?.Team_Channel_Id &&
                                      "active"
                                    }
                                  >
                                    <div
                                      className={[
                                        "comm-chatlist__item",
                                        chat?.Team_Channel_Id === activeChat?.Team_Channel_Id && activeChat?.Team_Channel_Id ? "comm-chatlist__item--active" : "",
                                        chat.unread_count > 0 ? "comm-chatlist__item--unread" : "",
                                      ].filter(Boolean).join(" ")}
                                    >
                                      <div className="comm-chatlist__item-avatar">
                                        {allusers.length > 1 ? (
                                          <AvatarStack
                                            layout="grid"
                                            size="md"
                                            avatars={[
                                              { name: allusers[0]?.FirstName },
                                              { name: allusers[1]?.FirstName },
                                              { name: allusers[2]?.FirstName },
                                            ]}
                                          />
                                        ) : (
                                          <Avatar
                                            src={user?.PhotoPath || ""}
                                            name={`${user?.FirstName || ""} ${user?.LastName || ""}`.trim()}
                                            size="md"
                                            status={mapUserStatus(user?.user_status)}
                                          />
                                        )}
                                      </div>

                                      <div className="comm-chatlist__item-body">
                                        <div className="comm-chatlist__item-row">
                                          <div className="comm-chatlist__item-name">
                                            {chat.Team_Channel_Description &&
                                              chat.Team_Channel_Description !=
                                              undefined &&
                                              chat.Team_Channel_Description !=
                                              null &&
                                              chat.Team_Channel_Description !=
                                              "private"
                                              ? chat.Team_Channel_Description
                                              : chat.em.length == 2
                                                ? user &&
                                                user.FirstName +
                                                " " +
                                                user.LastName
                                                : user &&
                                                user.FirstName +
                                                " " +
                                                user.LastName +
                                                " " +
                                                (chat.em.length - 1 > 1 &&
                                                  "   " +
                                                  chat.em.length -
                                                  2 +
                                                  " others")}
                                          </div>
                                          <div className="comm-chatlist__item-meta">
                                            {chat.unread_count > 0 && (
                                              <Badge variant="info" size="sm">
                                                {chat.unread_count}
                                              </Badge>
                                            )}
                                          </div>
                                        </div>

                                        <div className="comm-chatlist__item-preview">
                                          {getChatPreview(chat.lastmessage)}
                                        </div>
                                      </div>
                                    </div>
                                  </Nav.Link>
                                </Nav.Item>
                              );
                            })
                          ) : (
                            <p className="ml-5 text-secondary">
                              No Pinned Chats found
                            </p>
                          )}
                        </Nav>
                      </Accordion.Body>
                    </Accordion.Item>
                    <div className="comm-divider"></div>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <div className="comm-sidebar__section-label">
                          <div className="left">
                            <label htmlFor="">Recent</label>
                          </div>
                          <div className="right">
                            <Link to="#">
                              <img src={ic_dropdown} alt="" className="pe-1" />
                            </Link>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Nav variant="pills" className="flex-column">
                          {recentChatLdr ? (
                            <Beatloader />
                          ) : recentChats && recentChats.length ? (
                            recentChats.map((chat, index) => {
                              let allusers = chat.em
                                .sort((a, b) => a.EmployeeId - b.EmployeeId)
                                .filter(
                                  (user) => user.EmployeeId != userData.EmpId
                                );
                              let user = chat.em
                                .sort((a, b) => a.EmployeeId - b.EmployeeId)
                                .filter(
                                  (user) => user.EmployeeId != userData.EmpId
                                )[0];

                              return (
                                <Nav.Item
                                  key={"recent" + index}
                                  onClick={() => {
                                    setShowResults(false);
                                    setPage(0);
                                    setNoMorePages(false);
                                    setActiveChat({ pin: false, ...chat });
                                    setCurrentSChannel(chat.Team_Channel_Id);
                                    setSchannelName(
                                      chat?.Team_Channel_Description
                                        ? chat?.Team_Channel_Description
                                        : ""
                                    );
                                    joinRoom(chat.Team_Channel_Id);
                                  }}
                                >
                                  <Nav.Link
                                    eventKey={chat?.Team_Channel_Id}
                                    active={
                                      chat?.Team_Channel_Id ===
                                        activeChat?.Team_Channel_Id &&
                                        activeChat?.Team_Channel_Id
                                        ? true
                                        : false
                                    }
                                    className={
                                      chat?.Team_Channel_Id ===
                                      activeChat?.Team_Channel_Id &&
                                      activeChat?.Team_Channel_Id &&
                                      "active"
                                    }
                                  >
                                    <div
                                      className={[
                                        "comm-chatlist__item",
                                        chat?.Team_Channel_Id === activeChat?.Team_Channel_Id && activeChat?.Team_Channel_Id ? "comm-chatlist__item--active" : "",
                                        chat.unread_count > 0 ? "comm-chatlist__item--unread" : "",
                                      ].filter(Boolean).join(" ")}
                                    >
                                      <div className="comm-chatlist__item-avatar">
                                        {allusers.length > 1 ? (
                                          <AvatarStack
                                            layout="grid"
                                            size="md"
                                            avatars={[
                                              { name: allusers[0]?.FirstName },
                                              { name: allusers[1]?.FirstName },
                                              { name: allusers[2]?.FirstName },
                                            ]}
                                          />
                                        ) : (
                                          <Avatar
                                            src={user?.PhotoPath ? ApiConfig.BASE_URL_FOR_IMAGES + user.PhotoPath : ""}
                                            name={`${user?.FirstName || ""} ${user?.LastName || ""}`.trim()}
                                            size="md"
                                            status={mapUserStatus(user?.user_status)}
                                          />
                                        )}
                                      </div>

                                      <div className="comm-chatlist__item-body">
                                        <div className="comm-chatlist__item-row">
                                          <div className="comm-chatlist__item-name">
                                            {chat.Team_Channel_Description &&
                                              chat.Team_Channel_Description !=
                                              undefined &&
                                              chat.Team_Channel_Description !=
                                              null &&
                                              chat.Team_Channel_Description !=
                                              "private"
                                              ? chat.Team_Channel_Description
                                              : chat.em.length == 2
                                                ? user &&
                                                user.FirstName +
                                                " " +
                                                user.LastName
                                                : user &&
                                                user.FirstName +
                                                " " +
                                                user.LastName +
                                                " " +
                                                (chat.em.length - 1 > 1 &&
                                                  "   " +
                                                  chat.em.length -
                                                  1 +
                                                  " & others")}
                                          </div>
                                     
                                         
                                          <div className="comm-chatlist__item-meta">
                                            {chat.unread_count > 0 && (
                                              <Badge variant="info" size="sm">
                                                {chat.unread_count}
                                              </Badge>
                                            )}
                                          </div>
                                        </div>

                                        <div className="comm-chatlist__item-preview">
                                          {getChatPreview(chat.lastmessage)}
                                        </div>
                                      </div>
                                    </div>
                                  </Nav.Link>
                                </Nav.Item>
                              );
                            })
                          ) : (
                            <p className="ml-5 text-secondary">
                              No Recent Chats found
                            </p>
                          )}
                        </Nav>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <div className="comm-divider pt-3"></div>
                </div>
              </Tab.Container>
            </aside>
            <main className="comm-layout__main">
              <ChatBox
                showResults={showResults}
                setShowResults={setShowResults}
                createChatRoom={createChatRoom}
                setSelectedList={setSelectedList}
                selectedList={selectedList}
                schannelName={schannelName}
                setSchannelName={setSchannelName}
                filteredChats={filteredChats}
                setRecentChats={setRecentChats}
                updatePinUnpinChat={getAllRecentChats}
              />
              {/* <ChatBox /> */}
            </main>
          </div>
        </div>
      </>
  );
};

export default Chat;
